import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=4b09b8f7&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=4b09b8f7&prod&scoped=true&lang=css"
import style1 from "./LandingPage.vue?vue&type=style&index=1&id=4b09b8f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09b8f7",
  null
  
)

export default component.exports